// Simple greetings don't need a real model call - matching one locally skips the API
// entirely (and the AI-credit deduction that comes with it), keeping the round trip
// instant and free. Anything more substantial than a bare greeting still goes to Gemini.
const GREETING_PATTERNS = [
  /^(hi+|hello+|hey+|yo|sup|good\s?morning|good\s?afternoon|good\s?evening)[!.\s]*$/i,
  /^(chào|xin chào|chào bạn|chào buổi sáng|chào buổi chiều|chào buổi tối)[!.\s]*$/i,
];

const CANNED_GREETINGS = {
  strict: "Hey. Ready to look at your numbers, or just saying hi?",
  cute: "Hihi~ 💖 hey there bestie! What's up today?",
  wise: "Hello. I'm here whenever you'd like to talk about your finances.",
};

export function isCannedGreeting(text) {
  const trimmed = text.trim();
  if (!trimmed || trimmed.length > 24) return false;
  return GREETING_PATTERNS.some((pattern) => pattern.test(trimmed));
}

export function getCannedGreeting(personality) {
  return CANNED_GREETINGS[personality] || CANNED_GREETINGS.wise;
}
